export default __webpack_public_path__ + "static/media/hh17.2d90ba68.png";